import { Component, input, output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lib-mobile-menu-button',
  template: `
    <button
      type="button"
      (click)="onClick()"
      class="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-200"
      aria-controls="mobile-menu"
      [attr.aria-expanded]="isOpen()"
    >
      <span class="sr-only">{{
        isOpen() ? 'Close main menu' : 'Open main menu'
      }}</span>
      <div class="relative w-6 h-6">
        <div
          class="absolute inset-0 transform transition-transform duration-300"
          [class.rotate-180]="isOpen()"
        >
          @if (!isOpen()) {
          <svg
            class="block h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
          } @else {
          <svg
            class="block h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          }
        </div>
      </div>
    </button>
  `,
})
export class MobileMenuButtonComponent {
  readonly isOpen = input<boolean>(false);
  readonly toggle = output<void>();

  onClick(): void {
    this.toggle.emit();
  }
}
